import {
    moodboardAddLookButtonStyleChange,
    moodboardAddLookButtonStyleRollBack
} from './components/addLookToMoodboardButton';
import {click} from './tts'
import {createOrShowMoodboardPaywall, registerMoodboardPaywallClickEventListener} from "./moodboardPaywall";


const $ = require('jquery');
require('./share');
const {Router} = require('./router');
const tts = require('./tts');
let moodboardModule;
if (document.querySelector('.moodboards-container') !== null) {
    moodboardModule = require('../moodboard/add');
}
/** @property {Function} modal */
const viewer = $('#viewer');
const counter = $('#count-results');
const prevBtn = $('#carousel .viewer-previous');
const nextBtn = $('#carousel .viewer-next');
const lang = document.documentElement.lang;
const moreResultsBlock = $('#more-results');
const pagination = $('#nav-pagination');
const lastPage = pagination.attr('data-last-page') === undefined ? 1 : parseInt(pagination.attr('data-last-page'));
const selector = $('main');
const routeName = selector.attr('data-route');
const body = $('body');
const photoListItems = $('.photo-list-item');
const collectionItems = sessionStorage.getItem('collectionItems');
const memberJobs = $('.carousel-members').length > 0 ? JSON.parse($('.carousel-members').attr('data-jobs')) : [];
const spinner = $('<i class="fas fa-spinner fa-spin carousel-photo-zoom-loader"></i>');
let hasMoreResultsBlock = moreResultsBlock.length > 0,
    totalRes = counter.attr('data-total-count') !== undefined ? parseInt(counter.attr('data-total-count')) : null,
    currentItem,
    photoList = [],
    initialPage = parseInt(selector.attr('data-current-page')),
    ajaxInitRelated,
    ajaxInitPrContact;

/**
 * detect adblock
 *
 * @access private
 */
const detectAdblock = () => {
    if ($('#advertisement').css('display') === 'none') {
        $('.notice-unblock').show();
    }
}

document.addEventListener('DOMContentLoaded', async () => {
    const addToMoodboardButton = document.querySelector('.add-to-moodboard-button');

    if (addToMoodboardButton === null) {
        return;
    }

    if (localStorage.getItem('auth') !== 'logged') {
        addToMoodboardButton.classList.add('d-none');
    }

    resetAddToMoodboardButtonStyle();

    document.addEventListener('login:true', (e) => {
        addToMoodboardButton.addEventListener('click', async () => {
            let paywall = await createOrShowMoodboardPaywall();

            if (paywall) {
                return;
            }

            wireAddToMoodboardButton(addToMoodboardButton, e.detail);
        })
    });

    registerMoodboardPaywallClickEventListener();
    redirectIfUserNotLogged(addToMoodboardButton);

    if ($(collectionItems) !== undefined && $(collectionItems) !== null) {
        for (let i = 0; i < $(collectionItems).length; i++) {
            if ($(collectionItems).eq(i).hasClass('carousel-collection-item')) {
                $('.carousel-collection-list').append($(collectionItems).eq(i))
            }
        }
        $('.carousel-details-collection').css('display', 'block');
    }
    if (routeName !== 'trends_list') {
        fillPhotoList();
    }
    $(prevBtn).on('click', function (e) {
        e.preventDefault();
        prevPhoto();
    });
    $(nextBtn).on('click', function (e) {
        e.preventDefault();
        nextPhoto();
    });
    $(moreResultsBlock).on('click', function (e) {
        e.preventDefault();
        moreResultsBlock.one('results:more:done', function () {
            reloadPhotoList();
        });
    });

    document.addEventListener('nextResultsFetched', () => {
        reloadPhotoList();
    });


    $(document).on('keyup', function (e) {
        if (viewer.hasClass('active')) {
            switch (e.key) {
                case 'ArrowLeft':
                    prevPhoto();
                    break;
                case 'ArrowRight':
                    nextPhoto();
                    break;
            }
        }
    });

    viewer.on('hidden.bs.modal', function () {
        if ($(this).hasClass('zoom')) {
            return;
        }
        reset();
        if (
            currentItem['page'] !== initialPage
            && routeName !== 'streetstyle_index'
            && routeName !== 'model_show'
            && routeName !== 'trends_list'
        ) {
            let query = Object.assign(
                selector.attr('data-query') ? JSON.parse(selector.attr('data-query')) : {},
                {'page': currentItem['page']}
            );
            window.location.href = Router.generate(routeName + '.' + lang, query);
        }
    });
    viewer.find('.carousel-item-link img').on('load', function () {
        let ratio = this.width / this.height;
        ratio > 1 ? viewer.addClass('landscape') : viewer.removeClass('landscape');
    });

    detectAdblock();

    body
        .on('click', '.photo-list-item > a', open)
        .on('click', '.carousel-item-link', zoom)
        .on('click', '.carousel-designer-shop-link', saveClickAnalytic)
        .on('click', '.carousel-look-shop-link', saveClickAnalytic)
        .on('keydown', function (e) {
            if (e.key === 'Escape' && viewer.hasClass('zoom')) {
                viewer
                    .modal({
                        backdrop: 'static',
                        keyboard: false
                    })
                    .removeClass('zoom')
                    .addClass('active');
                $('.carousel-photo-zoom').remove();
            }
        });

});

const wireAddToMoodboardButton = (button, userInfo) => {
    if (
        button.classList.contains('add-to-moodboard-button-added')
        || button.classList.contains('add-to-moodboard-button-clicked')
        || !moodboardModule
    ) {
        return;
    }

    moodboardAddLookButtonStyleChange();

    if (userInfo['email'].length !== 0 && userInfo['job_title'] != null) {
        moodboardModule.initAddToMoodboardModal(currentItem);

        return;
    }

    moodboardModule.initNeedSubscription(currentItem);
}

const resetAddToMoodboardButtonStyle = () => {
    document.addEventListener('click', (e) => {
        const viewer = document.querySelector('#viewer');
        const arrowLeft = document.querySelector('.viewer-previous');
        const arrowRight = document.querySelector('.viewer-next');

        if ((viewer && !viewer.contains(e.target)) ||
            (arrowLeft && arrowLeft.contains(e.target)) ||
            (arrowRight && arrowRight.contains(e.target))) {
            moodboardAddLookButtonStyleRollBack();
        }
    });

    document.addEventListener('keydown', (e) => {
        const isArrowLeft = e.key === 'ArrowLeft';
        const isArrowRight = e.key === 'ArrowRight';

        if (isArrowLeft || isArrowRight) {
            moodboardAddLookButtonStyleRollBack();
        }
    });
}

const redirectIfUserNotLogged = (addToMoodboardButton) => {
    const loginStatus = localStorage.getItem('auth');

    if (loginStatus === 'anonymous') {
        addToMoodboardButton.addEventListener('click', () => {
            window.location.href = Router.generate('auth_index.' + lang);
        })
    }
}

/**
 * Open carousel
 *
 * @param event
 * @access private
 */
const open = (event) => {
    event.preventDefault();
    viewer.addClass('active');
    viewer.modal('show');

    if (routeName === 'trends_list') {
        photoList = [];
        let data = $(event.currentTarget).closest('.trend-tag-global').find('.photo-list-item');
        for (let i = 0; i < data.length; i++) {
            photoList.push(camelCasedDataToSpinalCase(data.eq(i).data()));
        }
    }
    currentItem = photoList[findBy('slug', $(event.currentTarget).parent().data()['slug'])];
    initCarousel();
    updateBtn();
}

const updateSessionStorage = () => {
    sessionStorage.setItem('query', JSON.stringify({
        'type': currentItem['type'],
        'designer': currentItem['designer-slug'],
        'season': currentItem['season-slug']
    }));
}

const hasSameDesignerSeasonType = () => {
    let result = JSON.parse(sessionStorage.getItem('query'));

    if (result === null) {
        return false;
    }

    return result['type'] === currentItem['type']
        && result['designer'] === currentItem['designer-slug']
        && result['season'] === currentItem['season-slug']
}

/**
 * Build template and listen to close
 *
 * @param event
 * @access private
 */
const zoom = (event) => {
    viewer.removeClass('active').addClass('zoom');
    body.prepend(spinner);
    let close = $('<div class="carousel-photo-zoom-btn"/>')
        .append('<i class="carousel-photo-zoom-close fal fa-times fa-3x"/>');
    let div = $('<div class="carousel-photo-zoom"/>')
        .append($('<img alt="" src="' + currentItem['img-zoom'] + '"/>'))
        .append(close);
    body.prepend(div);
    div.find('img').on('load', () => {
        $('.carousel-photo-zoom-loader').remove();
    });
    $('.carousel-photo-zoom, .carousel-photo-zoom-btn').on('click', function () {
        viewer.addClass('active').removeClass('zoom');
        $(this).closest('.carousel-photo-zoom').remove();
    });
    sendTtsEvent('photo_zoom');
    event.preventDefault();
}

/**
 * Get prev photo
 *
 * @access private
 */
const prevPhoto = () => {
    if (prevBtn.hasClass('disabled')) {
        return;
    }

    if (getCurrentItemPosition() === 0) {
        if (routeName === 'collection_show') {
            currentItem = photoList[photoList.length - 1];
            initCarousel();
            return;
        } else {
            getDataPage('prev');
            if (currentItem['page'] !== 1) {
                prevBtn.addClass('loading');
            }
            $(document).ajaxComplete(function () {
                initCarousel();
            });
        }
        return;
    }
    currentItem = photoList[getCurrentItemPosition() - 1];

    if (ajaxInitRelated && hasSameDesignerSeasonType() === false) {
        ajaxInitRelated.abort();
    }

    if (ajaxInitPrContact && sessionStorage.getItem('designer-slug') !== currentItem['designer-slug']) {
        ajaxInitPrContact.abort();
    }

    initCarousel();
    updateBtn();
}

/**
 * Get next photo
 *
 * @access private
 */
const nextPhoto = () => {
    if (nextBtn.hasClass('disabled')) {
        return;
    }

    if (getCurrentItemPosition() === photoList.length - 1) {
        if (routeName === 'collection_show') {
            currentItem = photoList[0];
            initCarousel();
            return;
        }

        if (hasMoreResultsBlock && hasMoreResults()) {
            moreResultsBlock.trigger('results:more');
            moreResultsBlock.one('results:more:done', function () {
                reloadPhotoList();
                moreResultsBlock.find('i').removeClass('fa-spin');
                currentItem = photoList[getCurrentItemPosition() + 1];
                initCarousel();
            });
        } else {
            getDataPage('next');
            nextBtn.addClass('loading');
            $(document).ajaxComplete(function () {
                initCarousel();
            });
        }
        return;
    }
    currentItem = photoList[getCurrentItemPosition() + 1];

    if (ajaxInitRelated && hasSameDesignerSeasonType() === false) {
        ajaxInitRelated.abort();
    }

    if (ajaxInitPrContact && sessionStorage.getItem('designer-slug') !== currentItem['designer-slug']) {
        ajaxInitPrContact.abort();
    }

    initCarousel();
    updateBtn();
}

/**
 * Init carousel
 *
 * @access private
 */
const initCarousel = () => {
    reset();
    initCarouselContent();
    sendTtsEvent('photo_view');
}

/**
 * Call ajax (pagination)
 *
 * @param {string} direction
 * @access private
 */
const getDataPage = (direction) => {
    let query;
    let route = $('#results').attr('data-path-more');

    if ((currentItem['page'] === lastPage && getCurrentItemPosition() === photoList.length - 1)
        || (currentItem['page'] === 1 && getCurrentItemPosition() === 0)
        || nextBtn.hasClass('loading')
        || prevBtn.hasClass('loading')) {
        return;
    }

    switch (direction) {
        case 'next':
            let pageNext = parseInt(currentItem['page']) < lastPage ? parseInt(currentItem['page']) + 1 : currentItem['page'];
            query = Object.assign(
                selector.attr('data-query') ? JSON.parse(selector.attr('data-query')) : {},
                {'page': pageNext}
            );
            break;
        case 'prev':
            let pagePrev = parseInt(currentItem['page']) > 0 ? parseInt(currentItem['page']) - 1 : currentItem['page'];
            query = Object.assign(
                selector.attr('data-query') ? JSON.parse(selector.attr('data-query')) : {},
                {'page': pagePrev}
            );
            break;
    }
    $.ajax({
        url: Router.generate(route + '.' + lang),
        method: 'GET',
        data: query
    }).done(function (data) {
        fillPhotoList(data, direction);
        currentItem = direction === 'next' ? photoList[getCurrentItemPosition() + 1] : photoList[getCurrentItemPosition() - 1];
        nextBtn.removeClass('loading');
        prevBtn.removeClass('loading');
    });
}

/**
 * Send analytics
 *
 * @param {string} event
 * @access private
 */
const sendTtsEvent = (event) => {
    if (currentItem['type'] === 'street') {
        tts.streetstyle(currentItem['slug'], event);
    } else {
        tts.media(currentItem['slug'], event);
    }
}

/**
 * reset carousel content
 *
 * @access private
 */
const reset = () => {
    viewer.find('.carousel-item-link img').attr('src', '/images/loader.gif');

    if (hasSameDesignerSeasonType() === false) {
        $('.carousel-collection-item').remove();
        $('.carousel-details-collection').hide();
    }
    $('.carousel-shop-item').remove();
    $('.carousel-individuals-item').remove();
    $('.carousel-designers-item').remove();
    $('.carousel-member-item').remove();
    $('.carousel-details-footer-container').hide();
    $('.carousel-details-individuals').hide();
    $('.carousel-details-designers').hide();
    $('.carousel-item-badge').hide();
    $('.carousel-members').hide();
}

/**
 * Init carousel content
 *
 * @access private
 */
const initCarouselContent = () => {
    let badge;
    let viewUrl;
    let text = currentItem['type'] !== undefined && currentItem['type'] === 'street' ?
        currentItem['season-name'] + " " + currentItem['city-name'] :
        currentItem['designer-name'] + " " + currentItem['season-name']
    ;

    if (currentItem['look']) {
        text += " Look " + currentItem['look'];
    }

    if (currentItem['type'] === 'street') {

        viewer.find('.carousel-details-header').hide();
        viewer.find('.viewer-header').hide();
        viewer.find('.carousel-models').hide();
        viewer.find('.carousel-models-agencies').hide();
        viewer.find('.carousel-people').show();
        viewer.find('.carousel-details-header').css('padding-top', '15px');
        viewer.find('.carousel-details-location').show()
            .find('.carousel-details-location-value').html(currentItem['city-name'])
            .attr('href', Router.generate('streetstyle_search.' + lang, {'city': currentItem['city-slug']}))
        ;
        initDesigners();
        viewUrl = Router.generate('streetstyle_show.' + lang, {'slug': currentItem['slug']}, true);
    } else {
        viewer.find('.viewer-header').show();
        viewer.find('.modal-photo-designer').html(currentItem['designer-name']);
        viewer.find('.modal-photo-season').html(currentItem['season-name']);
        viewer.find('.modal-photo-look').html(currentItem['look']);
        viewer.find('.carousel-models').show();
        viewer.find('.carousel-people').hide();
        viewer.find('.carousel-details-location').hide();
        viewUrl = Router.generate('look_show.' + lang, {'slug': currentItem['slug']}, true);
        badge = currentItem['badge'];


        if (currentItem['online-shop'] && currentItem['online-shop'].trim() !== '') {

            viewer.find('.carousel-look-shop-link').attr('href', currentItem['online-shop']);
            viewer.find('.carousel-details-shop-look').show();
            viewer.find('.carousel-details-shop').hide();
        } else {
            viewer.find('.carousel-details-shop-look').hide();
            viewer.find('.carousel-details-shop').show();
        }


        if (badge) {
            badge = badge.split('\n').join('<br />');
            viewer.find('.carousel-item-badge').show().html(badge);
        }
    }
    viewer.find('.carousel-item-link')
        .attr('href', currentItem['img-zoom'])
        .find('img').attr('src', currentItem['img'])
    ;
    viewer.find('.carousel-details-courtesy').html(currentItem['courtesy']);
    viewer.find('.share-icon').attr('data-url', viewUrl);
    viewer.find('.share-icon').attr('data-img', currentItem['img']);
    viewer.find('.share-icon').attr('data-text', text);
    initShop();
    initIndividuals();
    initPrContact();
    initMembers();

    if (currentItem['type'] !== 'street'
        && currentItem['designer-slug'] !== undefined
        && currentItem['season-slug'] !== undefined) {
        initRelatedPhotos();
    }
}

/**
 * Init shop in carousel content
 *
 * @access private
 */
const initShop = () => {
    if (isEmptyInCurrent('affiliations') === false) {
        let container = $('.carousel-shop-list-items');
        let affiliations = currentItem['affiliations'];
        const hoverText = $('.carousel-shop-item-text').html();
        const prototypeItem = $('.carousel-shop-prototype');

        affiliations.forEach(affiliation => {
            let itemBlock = $(prototypeItem).clone().show().attr('class', 'carousel-shop-item');
            itemBlock
                .find('.carousel-designer-shop-link')
                .attr('href', affiliation['link'])
                .attr('target', affiliation['link_target'])
                .find('.carousel-shop-item-text').html(affiliation.name)
            ;
            itemBlock.on('mouseenter', function () {
                $(this).find('.carousel-shop-item-text').html(hoverText);
            });
            itemBlock.on('mouseleave', function () {
                $(this).find('.carousel-shop-item-text').html(affiliation.name);
            });
            container.append(itemBlock);
        });
        $('.carousel-details-shop').show();
    }
}

/**
 * Init Individuals in carousel content
 *
 * @access private
 */
const initIndividuals = () => {
    if (isEmptyInCurrent('individuals') === false) {
        let individuals = currentItem['individuals'];
        let hasAgencies = individuals.map(individual =>
            individual['agencies'] !== undefined && individual['agencies'] !== null
        ).includes(true);

        if (hasAgencies === false) {
            viewer.find('.carousel-models-agencies').hide();
            viewer.find('.carousel-models').show();
        } else {
            viewer.find('.carousel-models-agencies').show();
            viewer.find('.carousel-models').hide();
        }

        viewer.find('.carousel-details-footer-container').show();
        const prototypeItem = currentItem['type'] === 'street' ?
            $('.carousel-people .carousel-individuals-prototype') :
            (hasAgencies ? $('.carousel-models-agencies .carousel-individuals-prototype') : $('.carousel-models .carousel-individuals-prototype'))
        ;
        const container = prototypeItem.closest('.carousel-individuals-list');

        individuals.forEach(individual => {
            let itemBlock = $(prototypeItem).clone();
            let individualLink = Router.generate('model_show.' + lang, {
                'slug': individual.slug
            });
            itemBlock.attr('class', 'carousel-individuals-item');
            itemBlock.show();
            $(itemBlock).find('.carousel-individuals-item-link').attr('href', individualLink);
            $(itemBlock).find('.carousel-individuals-item-name').html(individual.name);

            if (individual['agencies'] !== undefined && individual['agencies'] !== null) {
                individual['agencies'].forEach((agency, key, arr) => {
                    let agencyLink = Router.generate('agency_show.' + lang, {'slug': agency.slug});
                    let agencyLinkBlock = $("<a href='" + agencyLink + "'>" + agency.name + "</a>");
                    $(itemBlock).find('.carousel-individuals-item-agencies').append(agencyLinkBlock);
                    if (key !== arr.length - 1) {
                        $(itemBlock).find('.carousel-individuals-item-agencies').append(', ');
                    }
                });
            }
            container.append(itemBlock);
        });
        $('.carousel-details-individuals').show();
    }
}

/**
 * Call ajax (see all collection)
 *
 * @access private
 */
const initRelatedPhotos = () => {
    let query = {
        'type': currentItem['type'],
        'designer': currentItem['designer-slug'],
        'season': currentItem['season-slug'],
        'city': currentItem['city-slug']
    };

    if (hasSameDesignerSeasonType() === false) {
        const collectionBlock = $('.carousel-details-collection');
        const collectionList = $('.carousel-collection-list');
        const prototypeItem = $('.carousel-collection-prototype');
        let collectionLink = Router.generate('look_search.' + lang, query);

        if (!sessionStorage.getItem('query')) {
            sessionStorage.setItem('query', JSON.stringify(query));
        }

        updateSessionStorage();
        viewer.find('.carousel-details-collection').css('display', 'block');
        collectionBlock.attr('href', collectionLink);
        ajaxInitRelated = $.ajax({
            url: Router.generate('look_related.en'),
            method: 'GET',
            global: false,
            data: query
        }).done(function (data) {
            $.each(data, function (i, item) {
                let itemBlock = prototypeItem.clone();
                itemBlock.attr('class', 'carousel-collection-item');
                itemBlock.show();
                itemBlock.find('img').addClass('carousel-collection-item-img').attr('src', item.files[0]['path_thumbnail']);
                collectionList.append(itemBlock);
            });
            sessionStorage.setItem('collectionItems', $('.carousel-collection-list').html());
        });
    } else {
        let collectionLink = Router.generate('look_search.' + lang, query);
        $('.carousel-details-collection').attr('href', collectionLink);
    }

}

/**
 * Init designer in carousel content
 *
 * @access private
 */
const initDesigners = () => {
    if (isEmptyInCurrent('designers') === false) {
        let designers = currentItem['designers'];
        const prototypeItem = $('.carousel-designers-prototype');

        viewer.find('.carousel-details-footer-container').show().find('.carousel-details-designers').show();
        designers.forEach(designer => {
            let itemBlock = prototypeItem
                .clone()
                .attr('class', 'carousel-designers-item')
                .show()
            ;
            itemBlock
                .find('.carousel-designers-link')
                .attr('href', Router.generate('streetstyle_search.' + lang, {'designers': designer.slug}))
                .html(designer.name);
            $('.carousel-details-designers').append(itemBlock);

        });
    }
}

/**
 * Init members in carousel content
 *
 * @access private
 */
const initMembers = () => {
    if (isEmptyInCurrent('members') === false) {
        let team = memberJobs.reduce((o, k) => ({
            ...o,
            [k]: []
        }), {});
        let members = currentItem['members'];
        const prototype = $('.carousel-members-prototype');
        const slugs = [];
        viewer
            .find('.carousel-details-footer-container').show()
            .find('.carousel-members').show();
        members.forEach(member => {
            if (memberJobs.includes(member.job) && !team[member.job].includes(member.name)) {
                team[member.job].push(member.name);
                slugs[member.name] = member.slug;
            }
        });

        for (let job in team) {
            if (team.hasOwnProperty(job) && team[job].length > 0) {
                let reformatedJob = job.replace(' ', '_');
                let jobValue = Translator.transChoice(`member_jobs.${reformatedJob}`, team[job].length);

                let links = team[job].map(member => {
                    const query = {
                        'slug': slugs[member]
                    };

                    return `<a href="${Router.generate('member_show.' + lang, query)}"> ${member} </a>`
                })

                let names = links.join(', ');
                let item = prototype
                    .clone()
                    .attr('class', 'carousel-member-item')
                    .show();
                item.find('.carousel-member-value').html(`<span class="carousel-member-job">${jobValue}</span>: <span class="carousel-member-name">${names}</span>`);
                $('.carousel-members').append(item);
            }
        }
    }
}

/**
 * Init pr contact in carousel content
 *
 * @access private
 */
const initPrContact = () => {
    const prContact = $('.carousel-details-prcontact');

    if (currentItem['type'] === 'street') {
        prContact.hide();
        return;
    }

    if (sessionStorage.getItem('designer-slug') === null
        || sessionStorage['designer-slug'] !== currentItem['designer-slug']) {
        prContact.hide();
        let query = {
            'slug': currentItem['designer-slug']
        };
        ajaxInitPrContact = $.ajax({
            url: Router.generate('designer_ajax_get.' + lang, query),
            method: 'GET',
            global: false
        }).done(function (data) {
            sessionStorage.setItem('designer-slug', currentItem['designer-slug']);
            sessionStorage.setItem('designer-details', data['details'] !== null);
            if (data['details'] !== null) {
                prContact.show();
                prContact.attr('href', Router.generate('designer_details.' + lang, query));
            } else {
                prContact.hide();
            }
        });
    } else if (sessionStorage.getItem('designer-details') === 'true' && sessionStorage['designer-slug'] === currentItem['designer-slug']) {
        prContact.show();
        prContact.attr('href', Router.generate('designer_details.' + lang, {'slug': currentItem['designer-slug']}));
    } else {
        prContact.hide();
    }
}

const hasMoreResults = () => {
    return photoList.length < totalRes;
}

/**
 * Init photo list or concat news data
 *
 * @param {array} [data]
 * @param {string} [direction]
 * @access private
 */
const fillPhotoList = (data, direction) => {
    if (data === undefined && direction === undefined) {
        let tmpPhotoListItems = photoListItems.not('[aria-hidden=true]').not('.item-prototype');

        for (let i = 0; i < tmpPhotoListItems.length; i++) {
            photoList.push(camelCasedDataToSpinalCase(tmpPhotoListItems.eq(i).data()));
        }
        return;
    }
    switch (direction) {
        case 'next':
            for (let i = 0; i < data.length; i++) {
                photoList.push(camelCasedDataToSpinalCase(data[i]));
            }
            break;
        case 'prev':
            for (let i = data.length; i--;) {
                if (data[i] !== undefined) {
                    photoList.unshift(camelCasedDataToSpinalCase(data[i]));
                }
            }
            break;
    }
}

/**
 * Get position of current item
 *
 * @access private
 * @returns {number}
 */
const getCurrentItemPosition = () => {
    return photoList.indexOf(currentItem);
}

/**
 * Check if current attribute is undefined or null
 *
 * @param {string} attr
 * @returns {boolean}
 */
const isEmptyInCurrent = (attr) => {
    return currentItem[attr] === undefined || currentItem[attr] === null || !currentItem[attr].length;

}

/**
 * Find By attr
 * @param {string} attr
 * @param {string} value
 * @returns {number}
 */
const findBy = (attr, value) => {
    for (let i = 0; i < photoList.length; i++) {
        if (photoList[i][attr] === value) {
            return i;
        }
    }
    return 0
}

/**
 * Update btn addClass/RemoveClass
 */
const updateBtn = () => {
    if (routeName === 'collection_show') {
        return;
    }

    if (routeName === 'trends_list' && getCurrentItemPosition() === photoList.length - 1) {
        nextBtn.addClass('disabled');
    } else if (currentItem['page'] === lastPage && getCurrentItemPosition() === photoList.length - 1) {
        nextBtn.addClass('disabled');
    } else {
        nextBtn.removeClass('disabled');
    }

    if ((currentItem['page'] === 1 && getCurrentItemPosition() === 0)) {
        prevBtn.addClass('disabled');
    } else if (routeName === 'trends_list' && getCurrentItemPosition() === 0) {
        prevBtn.addClass('disabled');
    } else {
        prevBtn.removeClass('disabled');
    }
}

/**
 * Loop object, change key (camelCase to spinalCase)
 *
 * @param {object} data
 *
 * @return {object}
 */
const camelCasedDataToSpinalCase = (data) => {
    let tmp = {};

    for (const [k, v] of Object.entries(data)) {
        tmp[toSpinalCase(k)] = v;
    }

    return tmp;
}

/**
 * Parse string camelCase to spinalCase
 * return new string (spinalCase)
 *
 * @param str
 *
 * @return {string}
 */
const toSpinalCase = (str) => {
    return str.split('').map((c) => {
        if (c === c.toUpperCase() && c !== '-') {
            return '-' + c.toLowerCase();
        } else {
            return c;
        }
    })
        .join('');
}

/**
 * Send tts event (beacon) on aff. link click
 */
const purchase = () => {
    tts.purchase(currentItem['slug'], $(this).attr('href'));
}

const reloadPhotoList = () => {
    let data = $('.photo-list-item').not('.item-prototype').slice(photoList.length);

    for (let i = 0; i < data.length; i++) {
        photoList.push(camelCasedDataToSpinalCase(data.eq(i).data()));
    }
}

const saveClickAnalytic = (event) => {
    let element = event.target;
    element = element.closest('.carousel-designer-shop-link, .carousel-look-shop-link');

    if (!element) {
        return;
    }

    let slug = currentItem['slug'];
    let params = {
        'media_slug':  slug,
        'route': routeName
    };

    click(element.getAttribute('href'), params);
}
